// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/demand_confirm_record_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { DemandConfirmRecordService } from "./demand_confirm_record_service_pb";

/**
 * ListDemandConfirmRecords returns the list of demand confirm records
 * that match the supplied filters, sorted by confirmed_at descending.
 *
 * @generated from rpc bffuser.v1.DemandConfirmRecordService.ListDemandConfirmRecords
 */
export const listDemandConfirmRecords = DemandConfirmRecordService.method.listDemandConfirmRecords;
